import React, { useEffect } from 'react'
import './index.css'
import { connect } from 'react-redux';
import { useLocation, useNavigate } from 'react-router-dom';
import { updateAlert } from '../../redux/actions';
import Avatar, { genConfig } from 'react-nice-avatar';
import { Avatar as MuiAvatar } from "@mui/material";
// import ThemeButton from '../ThemeButton';


const getLocation = (location) => {
  return location.pathname.split("/")[2];
};


function Topbar(props) {
  const { theme } = props;
  const navigate = useNavigate();
  const location = useLocation();

  function stringAvatar() {
    return {
      sx: {
        bgcolor: '#40c6c1',
        transform: 'translateY(-5px)',
        fontSize: '18px',
      },
    };
  }

  const handleProjects = () => {
    navigate("/m2d/projects");
  };

  const handleModels = () => {
    navigate("/m2d/models");
  };

  const handleInbox = () => {
    navigate("/m2d/inbox");
  };

  const handleAdmin = () => {
    navigate("/m2d/hanyuhu");
  };

  const handleBugReport = () => {
    window.open("https://github.com/hulab-emory/hulab-apps-issues/issues/new/choose", "_blank")
  }

  const handleFeatures = () => {
    navigate("/features");
  };

  const handleProfile = () => {
    if (props.role !== "Guest") {
      navigate("/profile");
    } else {
      props.handleAlert("error", "What were you thinking? Guests don't get a userinfo page, get an account!", 4000)
    }
  };

  const handleHistory = () => {
    if (props.role !== "Guest") {
      navigate("/m2d/history");
    } else {
      props.handleAlert("error", "What were you thinking? Guests don't get a userinfo page, get an account!", 4000)
    }
  }

  const handleGetStarted = () => {
    if (props.role === "Guest") {
      props.handleLogout();
    }
    navigate("/modelmeetsdata");
  };

  const handleLogout = () => {
    props.handleLogout();
    navigate("/");
  };

  const handleMyModels = () => {
    if (props.role !== 'Admin' && props.role !== 'Internal') {
      return props.handleAlert("error", "Functionality ot avaiable for now!");
    }
    // props.handleAlert("error", "Under construction!");
    navigate("/m2d/mymodels");
  };

  // const handleChangeTheme = (e) => {
  //   // console.log(e.target.checked);
  //   // setDarkTheme(e.target.checked);
  //   props.handleTheme();
  // }

  useEffect(() => {
    document.documentElement.dataset.theme = theme;
  }, [theme]);

  return (
    <div className="topbar-layout">
      <div className="topbar-content">
        <div className="topbar-logo" onClick={handleGetStarted} />
        <section>
          <div className={`element${location.pathname === "/m2d"
            ||
            getLocation(location) === "projects"
            ?
            " element-active"
            :
            ""}`} onClick={handleProjects}>
            Projects
          </div>
          <div className={`element${getLocation(location) === "models"
            ?
            " element-active"
            :
            ""}`} onClick={handleModels}>
            Models
          </div>

          {props.user && props.role === "Admin" && (
            <div className={`element${getLocation(location) === "hanyuhu"
              ?
              " element-active"
              :
              ""}`} onClick={handleAdmin}>
              Admin
            </div>
          )}

        </section>
      </div>
      {/* <div className="theme-button">
        <ThemeButton
          onChange={handleChangeTheme}
          defaultValue={props.theme === "dark"}
        />
      </div> */}

      <div className="topbar-userinfo">
        <div className="avatar">
          <MuiAvatar {...stringAvatar(`${props.user.firstName} ${props.user.lastName}`)} >
            {props.user.avatar ?
              <Avatar style={{ width: '45px', height: '45px' }} {...genConfig(JSON.parse(props.user.avatar))} />
              :
              `${props.user.firstName[0].toUpperCase()}${props.user.lastName[0].toUpperCase()}`}
          </MuiAvatar>
        </div>
      </div>
      <div className="topbar-usermenu">
        <div className="topbar-usermenu-content">
          <div className="element">
            <div className="name">
              {props.user.firstName} {props.user.lastName}
            </div>
            <div className="username">
              {props.user.username}
            </div>
            <div className="element" onClick={handleProfile}>
              Profile
            </div>
            <div className="element" onClick={handleMyModels}>
              My Models
            </div>
            <div className="element" onClick={handleHistory}>
              History
            </div>
            <div className="element" onClick={handleInbox}>
              Inbox
            </div>
            <div className="element" onClick={handleFeatures}>
              Features
            </div>
            <div className="element" onClick={handleBugReport}>
              Bug Report
            </div>
            <div className="element" onClick={handleLogout}>
              Logout
            </div>
          </div>
        </div>

      </div>

    </div>
  )
}

const mapStateToProps = (state) => {
  return {
    user: state.main.user,
    version: state.m2d.version,
    role: state.m2d.role,
    theme: state.m2d.theme,
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
    handleLogout() {
      const action = {
        type: "logout",
      };
      const action2 = {
        type: "LOGOUT"
      }
      dispatch(action);
      dispatch(action2);
    },

    handleSidebar() {
      const action = {
        type: "sidebar",
      };
      dispatch(action);
    },

    handleAlert(alertType, alertMessage, time = 2500) {
      updateAlert(alertType, alertMessage, time)(dispatch);
    },

    handleTheme() {
      const action = {
        type: "switchTheme"
      };
      dispatch(action);
    }
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(Topbar)
